<template>
  <v-dialog
    v-model="computedDialogUiLegal"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card color="primary">
        <v-btn icon @click.native="methodDialogUi('dialogLegal')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>About/Legal</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-list three-line subheader>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Copyright Notice</v-list-tile-title>
              <v-list-tile-sub-title>{{ computedCopyrightNotice }}</v-list-tile-sub-title>
              <v-list-tile-sub-title>{{ computedCopyrightData }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>About GeoWB</v-list-tile-title>
              <v-list-tile-sub-title>{{ computedTitle }} was created in Whistler by Alchemy Mapping Solutions, Inc.</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card-text>

      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    computed: {
      computedDialogUiLegal () {
        return this.$store.state.dialogs.ui.dialogLegal
      },
      computedTitle () {
        return this.$store.state.general.title
      },
      computedCopyrightNotice () {
        return this.$store.state.general.copyrightNotice
      },
      computedCopyrightData () {
        return this.$store.state.general.copyrightData
      }
    },
    methods: {
      methodDialogUi (dialog) {
        this.$store.commit('mutationDialogUi', {
          dialog: dialog
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/dialogLegal.vue